var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCar(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "56.6929px",
    height: "34.1174px",
    viewBox: "0 0 56.6929 34.1174",
    style: {
      enableBackground: "new 0 0 56.6929 34.1174"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#202346;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.8432,30.3273h-2.8667v-1.335h2.7898c0.259-0.038,1.2513-0.2675,1.2513-1.5317v-4.158 c-0.0913-0.2378-1.061-2.1731-8.7082-3.5577l-0.2365-0.0433l-0.1551-0.1836c-0.0482-0.0574-4.855-5.7022-9.7771-6.5111H17.6025 c-0.0774-0.0068-3.8302-0.1705-6.1677,2.7489l-0.0686,0.0736c-0.0155,0.0145-1.6786,1.5937-1.6786,3.929v6.884 c0.0308,0.1788,0.3682,1.6386,3.1839,1.6386v1.335c-3.3744,0-4.4297-1.8801-4.5163-2.8741L8.3527,26.684v-6.9257 c0-2.7431,1.7682-4.5805,2.0686-4.8725c2.7784-3.4321,7.0386-3.2208,7.2204-3.213l10.6047-0.0011L28.298,11.68 c4.9646,0.7818,9.5625,5.7487,10.4816,6.7932c8.9067,1.6548,9.5361,4.2081,9.5716,4.7067l0.0015,4.2806 c0,2.0626-1.6191,2.7744-2.4754,2.8631L45.8432,30.3273z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 21.269,
    y: 28.4743,
    className: "st0",
    width: 13.2954,
    height: 1.335
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.9527,32.4561c-2.1165,0-3.8384-1.7221-3.8384-3.8384c0-2.1153,1.7218-3.8362,3.8384-3.8362 c2.1157,0,3.837,1.721,3.837,3.8362C19.7897,30.7341,18.0684,32.4561,15.9527,32.4561z M15.9527,26.1166 c-1.3801,0-2.5032,1.1217-2.5032,2.5012c0,1.3804,1.1231,2.5032,2.5032,2.5032c1.3797,0,2.502-1.1228,2.502-2.5032 C18.4547,27.2384,17.3323,26.1166,15.9527,26.1166z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.8912,32.4561c-2.1153,0-3.8362-1.7221-3.8362-3.8384c0-2.1153,1.721-3.8362,3.8362-3.8362 c2.1165,0,3.8384,1.721,3.8384,3.8362C43.7295,30.7341,42.0077,32.4561,39.8912,32.4561z M39.8912,26.1166 c-1.3792,0-2.5012,1.1217-2.5012,2.5012c0,1.3804,1.122,2.5032,2.5012,2.5032c1.3801,0,2.5032-1.1228,2.5032-2.5032 C42.3944,27.2384,41.2713,26.1166,39.8912,26.1166z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.8902,20.3643c-0.0166,0-0.0337-0.0005-0.0503-0.0021l-18.7014-1.3946 c-0.1945-0.0141-0.3726-0.1131-0.4881-0.2701c-0.1156-0.157-0.1567-0.3562-0.1126-0.546l0.7744-3.3372 c0.0834-0.3593,0.4401-0.5825,0.8013-0.4996c0.359,0.0834,0.5825,0.4423,0.4994,0.801l-0.5985,2.5789l17.9247,1.3366 c0.3677,0.0271,0.6436,0.3473,0.6162,0.715C35.529,20.0973,35.2361,20.3643,34.8902,20.3643z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 24.3068,
    y: 12.3392,
    className: "st0",
    width: 1.335,
    height: 6.5569
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.6538,25.4412h-2.474c-0.3687,0-0.6676-0.2988-0.6676-0.6676c0-0.3687,0.2988-0.6676,0.6676-0.6676h2.474 c0.3687,0,0.6676,0.2988,0.6676,0.6676C12.3214,25.1424,12.0226,25.4412,11.6538,25.4412z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.566,25.7567h-2.6339c-0.3687,0-0.6676-0.2988-0.6676-0.6676c0-0.3687,0.2989-0.6676,0.6676-0.6676h2.6339 c0.3687,0,0.6676,0.2988,0.6676,0.6676C48.2336,25.4579,47.9347,25.7567,47.566,25.7567z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCar);
export default __webpack_public_path__ + "static/media/icon-car.0e1390b4fc73569d99afd956637ab3cc.svg";
export { ForwardRef as ReactComponent };